import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { createBranch, updateBranch } from "../../../slices/company/branchSlice";
import Modal from "../../../components/modal";

const AddEditBranch = ({ show, branches = [], onClose, heading, initialData = {} }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    console.log(initialData);
    // Set initial state for form fields, with company_id from localStorage or branchData
    const [formValues, setFormValues] = useState({
        branch_name: initialData?.branch_name || '',
        branch_location: initialData?.branch_location || '',
        parent_branch: initialData?.parent_branch || '',
        company_id: initialData?.company_id || ''
    });

    useEffect(() => {
        setFormValues({
            branch_name: initialData?.branch_name || "",
            branch_location: initialData?.branch_location || "",
            parent_branch: initialData?.parent_branch || "",
            company_id:
                initialData?.company_id ||
                JSON.parse(localStorage.getItem("company"))?.company?.id ||
                "",
        });
    }, [initialData]);


    // // Load company_id from localStorage if not provided in branchData
    // useEffect(() => {
    //     if (!initialData?.company_id) {
    //         const company = JSON.parse(localStorage.getItem('company'));
    //         console.log('company checck ', company);
    //         setFormValues((prevValues) => ({
    //             ...prevValues,
    //             company_id: company.company?.id || '',
    //         }));
    //     }
    // }, [initialData]);


    useEffect(() => {
        setFormValues({
            branch_name: initialData?.branch_name || "",
            branch_location: initialData?.branch_location || "",
            company_id:
                initialData?.company_id ||
                JSON.parse(localStorage.getItem("company"))?.company?.id ||
                "",
        });
    }, [initialData]);

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (initialData?.id) {
            // Update branch
            dispatch(updateBranch({ id: initialData.id, branchData: formValues }));
        } else {
            // Add new branch
            dispatch(createBranch(formValues));
        }
        onClose();
        navigate("/branch"); // Redirect to branches list after submission
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >

            <div className="row">
                <div className="col-xl-12 col-xxl-12">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group mb-4">
                                    <label>Branch Name</label>
                                    <input
                                        type="text"
                                        name="branch_name"
                                        className="form-control"
                                        value={formValues.branch_name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="form-group mb-4">
                                    <label>Branch Location</label>
                                    <input
                                        type="text"
                                        name="branch_location"
                                        className="form-control"
                                        value={formValues.branch_location}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group mb-4">
                                    <label>Parent Branch</label>
                                    <select
                                        name="parent_branch"
                                        className="form-control"
                                        value={formValues.parent_branch}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">No Parent (Main Branch)</option>

                                        {branches
                                            .filter(
                                                (branch) =>
                                                    // Exclude self when editing
                                                    !initialData?.id || branch.id !== initialData.id
                                            )
                                            .map((branch) => (
                                                <option key={branch.id} value={branch.id}>
                                                    {branch.branch_name}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>



                            <div className="col-md-6">
                                <button type="submit" className="btn btn-primary btn-block">
                                    {initialData?.id ? "Update" : "Submit"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddEditBranch;
